<soft-page>
  <!--soft-page-header customClass="!p-0">
    <div class="app-header flex flex-row py-2 px-2">
      <soft-input
        [placeholder]="'Alle ' + applications().length + ' Applikationen durchsuchen...'"
        (valueChange)="newSearch.set($event)"
      ></soft-input>
      <button
        type="button"
        class="overview-button soft-button soft-button-outline flex items-center justify-center text-center button-height pointer bg-surface hover:text-primary ml-2"
        [ngClass]="
          mode() === 'grid' ? 'text-primary !border-primary' : 'text-[--inputBorderColor]'
        "
        title="{{ '#APP_OVERVIEW.GRID' | translate }}"
        (click)="setMode('grid')"
      >
        <i
          class="fa-regular fa-table-cells-large"
          [ngClass]="mode() === 'grid' ? 'fa-solid' : 'fa-regular'"
        ></i>
      </button>
      <button
        type="button"
        class="overview-button soft-button soft-button-outline flex items-center justify-center text-center button-height pointer bg-surface hover:text-primary"
        [ngClass]="
          mode() === 'list' ? 'text-primary !border-primary' : 'text-[--inputBorderColor]'
        "
        title="{{ '#APP_OVERVIEW.LIST' | translate }}"
        (click)="setMode('list')"
      >
        <i
          class="fa-regular fa-list"
          [ngClass]="mode() === 'list' ? 'fa-solid' : 'fa-regular'"
        ></i>
      </button>
      @if (config?.isGroupButtonActive) {
        <button
          type="button"
          class="overview-button soft-button soft-button-outline flex items-center justify-center text-center button-height pointer bg-surface hover:text-primary ml-2"
          [ngClass]="
            isGrouped() ? 'text-primary !border-primary' : 'text-[--inputBorderColor]'
          "
          title="{{ '#APP_OVERVIEW.LIST' | translate }}"
          (click)="isGrouped.set(!isGrouped())"
        >
          <i
            class="fa-regular fa-layer-group"
            [ngClass]="isGrouped() ? 'fa-solid' : 'fa-regular'"
          ></i>
        </button>
      }
      @if (nonPermittedAppsPermission()) {
        <button
          type="button"
          class="overview-button soft-button soft-button-outline flex items-center justify-center text-center button-height pointer bg-surface hover:text-primary ml-2"
          [ngClass]="
            showNonPermittedApps()
              ? 'text-primary !border-primary'
              : 'text-[--inputBorderColor]'
          "
          title="{{ '#APP_OVERVIEW.LIST' | translate }}"
          (click)="showNonPermittedApps.set(!showNonPermittedApps())"
        >
          <i
            class="fa-regular"
            [ngClass]="
              showNonPermittedApps() ? 'fa-solid fa-lock-open' : 'fa-regular fa-lock'
            "
          ></i>
        </button>
      }
    </div>
  </soft-page-header-->

  <div class="w-full flex flex-col">
    @if (permissions$ | async; as permissions) {
      @if (isGrouped()) {
        <cdk-accordion [multi]="true">
          @for (group of moduleGroups(); track group.id; let index = $index) {
            @if (group.name !== 'none') {
              <cdk-accordion-item
                [expanded]="group.expansion"
                #accordionItem="cdkAccordionItem"
              >
                <div
                  class="w-full flex items-center justify-between border-b p-2"
                  tabindex="0"
                  (click)="
                    setExpansion(group.id, !group.expansion); accordionItem.toggle()
                  "
                  [attr.id]="'accordion-header-' + index"
                  [attr.aria-expanded]="accordionItem.expanded"
                  [attr.aria-controls]="'accordion-body-' + index"
                >
                  <span class="text-lg font-semibold flex items-center gap-2">
                    <soft-icon [name]="group.icon"></soft-icon
                    >{{ group.name | translate }}</span
                  >
                  <soft-icon
                    [name]="
                      accordionItem.expanded
                        ? 'fa-regular fa-chevron-up'
                        : 'fa-regular fa-chevron-down'
                    "
                  ></soft-icon>
                </div>
              </cdk-accordion-item>
            }
            @if (group.expansion) {
              <div
                class="pb-2 mb-2"
                [ngClass]="mode() === 'list' ? 'grid-container-list' : 'grid-container'"
                [class]="group.name !== 'none' ? 'pt-2' : ''"
              >
                @for (
                  application of group.applications;
                  track index;
                  let index = $index
                ) {
                  @if (mode() === 'grid') {
                    <soft-app-grid
                      [id]="'softapps-allgemein-modules-griditem-' + application.name"
                      [application]="application"
                      [canPin]="canPin(application)"
                      [pinned]="isPinned(application)"
                      (pinChange)="togglePin(application)"
                      (navigate)="navigate($event)"
                      [showColor]="isGrouped()"
                      [showMetadata]="
                        (nonPermittedAppsPermission() && showNonPermittedApps()) || false
                      "
                    >
                    </soft-app-grid>
                  }
                  @if (mode() === 'list') {
                    <soft-app-list
                      [id]="'softapps-allgemein-modules-listitem-' + application.name"
                      [application]="application"
                      [canPin]="canPin(application)"
                      [pinned]="isPinned(application)"
                      (pinChange)="togglePin(application)"
                      (navigate)="navigate($event)"
                      [showColor]="isGrouped()"
                    >
                    </soft-app-list>
                  }
                }
              </div>
            }
          }
        </cdk-accordion>
      } @else if (!isGrouped()) {
        <div
          class="grow"
          [ngClass]="mode() === 'list' ? 'grid-container-list' : 'grid-container'"
        >
          @for (application of applications(); track index; let index = $index) {
            @if (mode() === 'grid') {
              <soft-app-grid
                [id]="'softapps-allgemein-modules-griditem-' + application.name"
                [application]="application"
                [canPin]="canPin(application)"
                [pinned]="isPinned(application)"
                (pinChange)="togglePin(application)"
                (navigate)="navigate($event)"
                [showColor]="isGrouped()"
                [showMetadata]="
                  (nonPermittedAppsPermission() && showNonPermittedApps()) || false
                "
              >
              </soft-app-grid>
            }
            @if (mode() === 'list') {
              <soft-app-list
                [id]="'softapps-allgemein-modules-listitem-' + application.name"
                [application]="application"
                [canPin]="canPin(application)"
                [pinned]="isPinned(application)"
                (pinChange)="togglePin(application)"
                (navigate)="navigate($event)"
                [showColor]="isGrouped()"
              >
              </soft-app-list>
            }
          }
        </div>
      }
    }
  </div>
</soft-page>

<ng-template #overviewMenuTemplate>
  <soft-menu-bar-pill-switch
    [value]="mode()"
    (valueChange)="setMode($any($event))"
    [iconOnly]="true"
    tooltip="Anzeige"
    [options]="[
      { label: 'Kacheln', value: 'grid', icon: 'fa-regular fa-table-cells-large' },
      { label: 'Liste', value: 'list', icon: 'fa-regular fa-list' },
    ]"
  ></soft-menu-bar-pill-switch>
</ng-template>

<ng-template #adminMenuTemplate>
  @if (config?.isGroupButtonActive) {
    <div class="h-full min-h-8 w-px select-none mx-0.5">&nbsp;</div>
    <soft-menu-bar-toggle-button
      [backgroundStyle]="'outline'"
      #button
      tooltip="Gruppiert"
      [value]="isGrouped()"
      (valueChange)="isGrouped.set(!isGrouped())"
      [values]="[true, false]"
    >
      <ng-container
        *ngTemplateOutlet="
          groupedButtonTemplate;
          context: { $implicit: isGrouped(), label: 'Gruppiert' }
        "
      ></ng-container>
    </soft-menu-bar-toggle-button>
    <ng-template #groupedButtonTemplate let-value let-label="label">
      <div
        class="flex gap-1 items-center font-semibold scale-110 transition-all duration-200"
      >
        @if (value !== null) {
          <soft-icon
            class="text-sm"
            [name]="
              value === false ? 'fa-regular fa-layer-group' : 'fa-solid fa-layer-group'
            "
          ></soft-icon>
        }
      </div>
    </ng-template>
  }
  @if (nonPermittedAppsPermission()) {
    <div class="h-full min-h-8 w-px select-none mx-0.5">&nbsp;</div>
    <soft-menu-bar-toggle-button
      [backgroundStyle]="'outline'"
      #button
      tooltip="Berechtigungen"
      [value]="showNonPermittedApps()"
      (valueChange)="showNonPermittedApps.set(!showNonPermittedApps())"
      [values]="[true, false]"
    >
      <ng-container
        *ngTemplateOutlet="
          nonPermittedButtonTemplate;
          context: { $implicit: showNonPermittedApps(), label: 'Berechtigungen' }
        "
      ></ng-container>
    </soft-menu-bar-toggle-button>
    <ng-template #nonPermittedButtonTemplate let-value let-label="label">
      <div
        class="flex gap-1 items-center font-semibold scale-110 transition-all duration-200"
      >
        @if (value !== null) {
          <soft-icon
            class="text-sm"
            [name]="value === false ? 'fa-regular fa-lock' : 'fa-solid fa-lock-open'"
          ></soft-icon>
        }
      </div>
    </ng-template>
  }
</ng-template>
